import React from "react";
import { Link } from "react-router";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="max-w-4xl mx-auto p-6 py-12">
        <h1 className="text-4xl font-bold mb-6 text-red-500">Terms of Service & End User License Agreement (EULA)</h1>

        <p className="mb-6 text-gray-400 text-sm">Last updated: November 16, 2025</p>

        <p className="mb-6 text-gray-300 leading-relaxed">
          Welcome to Noleyo! By accessing or using our app, you agree to comply with and be bound by these Terms of Service (the "Terms"). If
          you do not agree, please do not use Noleyo.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">1. Acceptance of Terms</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          By using Noleyo, you confirm that you are at least 13 years old (or the minimum age required in your country) and have the legal
          capacity to agree to these Terms.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">2. User Accounts</h2>
        <ul className="list-disc list-inside mb-6 text-gray-300 space-y-2">
          <li>You must provide accurate information when creating an account.</li>
          <li>You are responsible for maintaining the security of your account.</li>
          <li>Noleyo is not responsible for unauthorized access due to your failure to secure your credentials.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">3. User-Generated Content</h2>
        <p className="mb-4 text-gray-300 leading-relaxed">
          Noleyo allows users to create chatrooms, send messages, and interact with others. By using these features, you agree to:
        </p>
        <ul className="list-disc list-inside mb-6 text-gray-300 space-y-2">
          <li>Not post illegal, harmful, or offensive content.</li>
          <li>Respect other users and avoid harassment, hate speech, or abusive behavior.</li>
          <li>Understand that Noleyo may remove or moderate content that violates our policies.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">4. Content Moderation & Reporting</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          Noleyo provides mechanisms to report inappropriate content and block users. Reports are reviewed within 24 hours, and we may take
          action, including removing content or banning users who violate our policies.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">5. License & Restrictions</h2>
        <ul className="list-disc list-inside mb-6 text-gray-300 space-y-2">
          <li>Noleyo grants you a limited, non-exclusive, non-transferable license to use the app.</li>
          <li>You may not reverse-engineer, distribute, or use Noleyo for unlawful purposes.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">6. Privacy & Data Collection</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          Your use of Noleyo is also governed by our{" "}
          <Link to="/privacy-policy" className="text-red-400 hover:text-red-300 underline transition-colors">
            Privacy Policy
          </Link>
          , which outlines how we collect, use, and protect your data.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">7. Termination</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          We reserve the right to terminate or suspend your access to Noleyo if you violate these Terms or engage in behavior that harms our
          community.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">8. Changes to These Terms</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          Noleyo may update these Terms from time to time. We will notify you of significant changes through the app or via email.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-red-400">9. Contact Information</h2>
        <p className="mb-6 text-gray-300 leading-relaxed">
          If you have questions about these Terms, please contact us at{" "}
          <a href="mailto:support@noleyo.com" className="text-red-400 hover:text-red-300 underline transition-colors">
            support@noleyo.com
          </a>
          .
        </p>

        <p className="mt-8 text-gray-500 text-sm border-t border-gray-800 pt-6">
          By using Noleyo, you acknowledge that you have read, understood, and agreed to these Terms.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
